import React from 'react';
import { Platform } from 'react-native';

import TabErrorTooltip from './tab-error-tooltip';
import type { UseSound } from '../../../../hooks/use-sound';
import type { TabActivityStepInterface } from '../../../../interfaces/tab-activity';
import TitleAudioPlayer from '../../title-audio-player/title-audio-player';

interface TabActivityCardTitleAudioProps {
  item: TabActivityStepInterface;
  active: boolean;
  cardWidth: number;
  sound: UseSound;
  showTooltipError?: boolean;
}

const TabActivityCardTitleAudio: React.FC<TabActivityCardTitleAudioProps> = ({
  item,
  active,
  cardWidth,
  sound,
  showTooltipError = false,
}) => {
  const styles = {
    titleAudioPlayer: {
      borderBottomLeftRadius: Platform.OS === 'web' && !active ? 8 : 0,
      borderBottomRightRadius: Platform.OS === 'web' && !active ? 8 : 0,
    },
  };

  return (
    <TabErrorTooltip isVisible={showTooltipError}>
      <TitleAudioPlayer
        active={active}
        style={{
          width: cardWidth,
          ...styles.titleAudioPlayer,
        }}
        title={item.word}
        sound={sound}
      />
    </TabErrorTooltip>
  );
};

export default TabActivityCardTitleAudio;
